import axios from 'axios';
import { config } from '../apiConfig';

const AgencyProfile = async (method, parameters, conf) => {
    let result = '';
    let AccessToken = localStorage.getItem('AccessToken');
    if (AccessToken) {
    if (conf) {
        let response = await axios.post(`${config.url}/api/mvc/AgencyProfile/${method}`, parameters, conf)
                .then(function (response) {
                    return response;
                }).catch(function (error) {
                    return error.response.data;
                });
            if (response.status === 200) {

                result = {
                    status: 'success',
                    data: response
                };
            } else {
                result = {
                    status: 'faild',
                    data: response
                };
            }
            return result;
        } else {
        let response = await axios.post(`${config.url}/api/mvc/AgencyProfile/${method}`, parameters,{
                headers: { "Authorization": `Bearer ${AccessToken}` }
            })
                .then(function (response) {
                    return response;
                }).catch(function (error) {
                    return error.response.data;
                });

            if (response.status === 200) {
                result = {
                    status: 'success',
                    data: response
                };
            } else {
                result = {
                    status: 'faild',
                    data: response
                };
            }
            return result;
        }
    } else {
        window.location.href = 'https://iranhotelonline.com';

    }

}

export default AgencyProfile;